import React from 'react';
import { User } from 'lucide-react';
import { typography } from '../../styles/typography';
import { formatLostFoundDate } from './lostAndFoundData';
import { isLikelyOpaqueId } from './lostAndFoundApi';

const DetailRow = ({ label, value }) => (
  <div className="flex justify-between items-start gap-4 text-sm font-['Open_Sans']">
    <span className="text-gray-500 shrink-0">{label}</span>
    <span className="text-black font-medium text-right break-words">{value || '—'}</span>
  </div>
);

const displayValue = value => {
  const s = String(value ?? '').trim();
  if (!s) return '';
  return isLikelyOpaqueId(s) ? '' : s;
};

const formatBlockFlat = collection => {
  if (!collection) return '—';
  const block = displayValue(collection.block);
  const flat = displayValue(collection.flat);
  if (block && flat) return `${block} — ${flat}`;
  return block || flat || '—';
};

const CollectedByDetails = ({ collection, isResolvingLabels }) => {
  const blockFlat = isResolvingLabels && !displayValue(collection?.block)
    ? 'Loading…'
    : formatBlockFlat(collection);

  return (
    <div className="flex flex-col gap-4 lg:border-l lg:border-zinc-200 lg:pl-8 lg:pt-0 pt-6 border-t lg:border-t-0 border-zinc-200">
      <h4 className={`${typography.h5} text-black font-['Open_Sans'] normal-case`}>
        Collected by
      </h4>

      <div className="flex flex-col sm:flex-row lg:flex-col gap-4 items-start">
        <div className="shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-xl border border-zinc-200 bg-gray-50 overflow-hidden flex items-center justify-center">
          {collection?.person_photo_url ? (
            <img
              src={collection.person_photo_url}
              alt={collection.person_name || 'Collector'}
              className="w-full h-full object-cover"
            />
          ) : (
            <User className="w-8 h-8 text-gray-300" aria-hidden />
          )}
        </div>

        <div className="flex-1 min-w-0 flex flex-col gap-2.5">
          <DetailRow label="name" value={collection?.person_name} />
          <DetailRow label="mobile" value={collection?.mobile_number} />
          <DetailRow label="Block/flat" value={blockFlat} />
          <DetailRow label="description" value={collection?.description} />
          {collection?.collected_at && (
            <DetailRow
              label="collected on"
              value={formatLostFoundDate(collection.collected_at.split('T')[0])}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CollectedByDetails;
